import last from 'lodash/last';
import { Tweet } from 'react-twitter-widgets';
import YouTube from 'react-youtube';
import { Post } from 'lib/types';
import { getYoutubeVideoId, isYouTubeEmbedDisabled } from 'lib/helpers';
import { NETWORKS } from 'lib/constants';
import TikTokEmbed from 'components/TikTokEmbed/TikTokEmbed';
import { LoadingAnimation } from 'components/LoadingAnimation';
import { imagePostUrl } from 'lib/utils/imageUtils';
import { EmbedFallback } from './EmbedFallback';
import { InstagramEmbedWithFallback } from './InstagramEmbedWithFallback';
import { TwitchEmbed } from './TwitchEmbed';
import { ThreadsEmbed } from './ThreadsEmbed';
import { LinkedinEmbed } from './LinkedinEmbed';

interface Props {
  post: Post;
}

export const PostEmbed = ({ post }: Props) => {
  if (!post.id) {
    return <LoadingAnimation loading textArray={['Loading post...']} />;
  }

  const networkName = (NETWORKS[post.network] || {}).name;

  if (!post.isLive) {
    return <EmbedFallback post={post} />;
  }

  if (networkName === 'twitter') {
    const tweetId = last(post.url.split('/status/')) as string;
    return (
      <Tweet
        tweetId={tweetId}
      />
    );
  } if (networkName === 'instagram') {
    return <InstagramEmbedWithFallback post={post} />;
  }

  if (networkName === 'facebook') {
    return <EmbedFallback post={post} />;
  }

  if (networkName === 'youtube') {
    if (isYouTubeEmbedDisabled(post.account)) {
      return <EmbedFallback post={post} />;
    }
    return (
      <YouTube
        videoId={getYoutubeVideoId(post.url)}
        containerClassName="youtubeContainer"
        opts={{ width: '100%' }}
      />
    );
  }

  if (networkName === 'tiktok') {
    return (
      <TikTokEmbed post={post} />
    );
  }

  if (networkName === 'twitch') {
    return (
      <TwitchEmbed post={post} />
    );
  }

  if (networkName === 'threads') {
    return (
      <ThreadsEmbed post={post} />
    );
  }

  if (networkName === 'linkedin') {
    return (
      <LinkedinEmbed post={post} />
    );
  }

  if (networkName === 'snapchat') {
    return (
      <EmbedFallback post={post} />
    );
  }

  const backgroundImageStyle = {
    backgroundImage: post.thumbnailUrl ? `url(${imagePostUrl(post.thumbnailUrl, { isDead: !post.isLive })})` : 'none',
  };
  return (
    <div className="bg-contain bg-no-repeat h-full" style={backgroundImageStyle} />
  );
};
